//# Enums by Category

export enum MetaDetaExplorerTree {
  TopAutoScoreImageSearchAutomatically = 'Tree.TopAutoScoreImageSearchAutomatically',
  TopAutoScoreImageListValue = 'Tree.TopAutoScoreImageListValue',
  TopAutoScoreImageGroup = 'Tree.TopAutoScoreImageGroup',
  TopAutoScoreImageSetting = 'Tree.TopAutoScoreImageSetting',
}
